import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import UpcomingEvents from '../../components/UpcomingEvents';
import { getUpcomingEvents, getEventsOnDay } from './UpcomingEventsAPI';
import VenueShape from '../../components/types/venue';
import Logger from '../../utils/logger';

const UpcomingEventsContainer = ({
  $rootScope,
  className,
  day,
  eventId,
  isMobile,
  sameDay,
  venue,
  venueId,
}) => {
  const [events, setEvents] = useState([]);

  const fetchUpcomingEvents = async () => {
    const eventsEndpoint = sameDay
      ? getEventsOnDay
      : getUpcomingEvents;

    if (!venueId) return;

    const params = {
      venue_id: venueId,
    };

    if (sameDay) {
      params.day = day;
    }

    try {
      let rawEvents = await eventsEndpoint(params);
      rawEvents = rawEvents.filter((event) => event.eventId !== eventId);

      const mappedEvents = rawEvents.map((event) => ({
        url_slug: event.eventSlug,
        date: event.date,
        name: event.title,
        id: event.eventId,
        is_global_dining_access: event.isGda,
        image_preview: event.photo,
        responsive_images: event.responsiveImages,
        time: event.time,
      }));

      setEvents(mappedEvents);
    } catch (err) {
      Logger.error(err);
    }
  };

  useEffect(() => {
    fetchUpcomingEvents();
  }, [venueId, day]);

  if (!events.length) return null;
  return (
    <UpcomingEvents
      className={className}
      isMobile={isMobile}
      previewMode={$rootScope.previewMode}
      upcomingEvents={events}
      venue={venue}
    />
  );
};

UpcomingEventsContainer.displayName = 'UpcomingEventsContainer';

UpcomingEventsContainer.propTypes = {
  $rootScope: PropTypes.shape({
    previewMode: PropTypes.bool,
  }),
  className: PropTypes.string,
  day: PropTypes.string,
  eventId: PropTypes.number.isRequired,
  isMobile: PropTypes.bool,
  sameDay: PropTypes.bool,
  venue: VenueShape.isRequired,
  venueId: PropTypes.number.isRequired,
};

UpcomingEventsContainer.defaultProps = {
  $rootScope: {
    previewMode: false,
  },
  className: undefined,
  day: undefined,
  sameDay: false,
  isMobile: false,
};

export default UpcomingEventsContainer;
